import { useMemo } from "react";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { ReportTestTypePrerequisiteAttribute } from "app/api/graph/security-attributes";

type Result = GeneralResult & {
    canComplete: boolean;
};

export const useReportTestTypePrerequisitePermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canComplete: permissions?.includes(ReportTestTypePrerequisiteAttribute.CanComplete) ?? false,
        }),
        [permissions],
    );
};
